// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1EcwM","productName":"Table_productName__1yz4c"};